import keyboard from "@main/helpers/keyboard";

$(document).ready(function() {

    /* HEADER */

    /* раскрытие подменю */
    const $mainMenu = $(".js-main-menu");

    if($mainMenu.length) {

        const $memuItem = $mainMenu.find(".main-menu__item");

        if($(window).innerWidth() <= 768){

            $memuItem.each(function(){

                let t = $(this);

                t.find(".main-menu__item-link")
                    .on("click", function(e){

                        if($(this).siblings(".sub-menu-wrap").length > 0){

                            e.preventDefault();
                        }

                        t.toggleClass("active");
                    });
            });

        }

    }

    /* добавить класс arrowed, если есть подменю 2-го уровня */
    if($mainMenu.length) {

        $mainMenu.find(".sub-menu__item").each(function(){

            if($(this).has(".sub-menu-inner").length) {
                $(this).addClass("arrowed");
            }

        });

    }


    /* закрытие фиксированного меню на мобиле */
    const $closeMenuBtn = $(".js-btn-close-menu");

    if($closeMenuBtn.length) {

        $closeMenuBtn.on("click", function() {
            showingModal(false, ".js-header-nav");
        });
    }


    /* открытие фиксированного меню на мобиле */
    const $openMenuBtn = $(".js-btn-open-menu");

    if($openMenuBtn.length) {

        $openMenuBtn.on("click", function() {
            showingModal(true, ".js-header-nav");
        });
    }

    /* открытие окна поиска */
    const $openSearchBtn = $(".js-open-search");

    let isOpenedOnce = false;

    if($openSearchBtn.length){

        $openSearchBtn.on("click", function(){

            isOpenedOnce = true;

            $(".js-search-wrap").fadeIn();

            setTimeout(function(){
                $(".js-input-search").focus();
            },0);

        });

    }

    /* закрытие окна поиска */
    const $closeSearchBtn = $(".js-btn-close-search");

    if($closeSearchBtn.length) {

        const $searchWrap = $(".js-search-wrap");

        $closeSearchBtn.on("click", function() {
            $(".js-search-wrap").fadeOut();
        });

        $(document).mouseup(function(e){

            if (!$searchWrap.is(e.target)
                && $searchWrap.has(e.target).length === 0
                && isOpenedOnce) {

                $(".js-search-wrap").fadeOut();
            }
        });

        $(document).keyup(function(e){
            if(e.keyCode == keyboard.ESCAPE){
                $(".js-search-wrap").fadeOut();
            }
        });
    }


    function showingModal(isShow, node, animIn, animOut) {

        if(isShow == undefined){
            return false;
        }

        if(animIn == undefined) {
            animIn = "slide-in-right";
        }

        if(animOut == undefined) {
            animOut = "slide-out-right";
        }

        if(isShow){
            $(node).addClass(animIn)
                .removeClass(animOut);
        }else{
            $(node).addClass(animOut)
                .removeClass(animIn);
        }

        return false;

    }


});
